// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : utility functions for date handling
// =============================================================================
// ---Third-party imports
import { formatISO, subDays } from 'date-fns';
// ---Framework imports
import { dict } from 'ldash';
// ---Exports
export const isoToday = ()=>formatISO(new Date(), {
        representation: 'date'
    });
export const isoDate = (d)=>formatISO(d, {
        representation: 'date'
    });
const granularities = [
    'year',
    'quart',
    'month',
    'week',
    'day'
];
export const interval2granularity = dict(granularities.map((g)=>[
        g,
        g[0].toUpperCase()
    ]));
export const granularity2interval = dict(granularities.map((g)=>[
        g[0].toUpperCase(),
        g
    ]));
// limits for granularities
// attention: should be ascending sorted
export const GranularityStrategy = {
    D: null,
    W: null,
    M: null,
    Q: null,
    Y: null
};
